import { Drawer as MuiDrawer } from '@material-ui/core';
import { ComponentType } from 'react';
import { css } from 'styled-components';

import useScreenSize from '@sorare/core/src/hooks/device/useScreenSize';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';
import { OverrideClasses, regularMaterial } from '@sorare/core/src/style/utils';

const [Drawer, classes] = OverrideClasses(MuiDrawer, null, {
  paper: css`
    width: 100%;
    ${regularMaterial}
    @media ${tabletAndAbove} {
      width: 480px;
    }
  `,
});

type CardOpened = {
  cardSlug: string;
  playerSlug: string;
};

export type PlayerDetails = ComponentType<{
  onClose: () => void;
  playerSlug: string;
  cardSlug: string;
  showCardBonusIndicator?: boolean;
}>;

export type Props = {
  cardOpened: CardOpened | null;
  onClose: () => void;
  PlayerDetails: PlayerDetails;
};

export const PlayerDrawer = ({ cardOpened, onClose, PlayerDetails }: Props) => {
  const { up: isTabletOrAbove } = useScreenSize('tablet');

  return (
    <Drawer
      open={!!cardOpened}
      anchor={isTabletOrAbove ? 'right' : 'bottom'}
      disablePortal={false}
      classes={{
        paper: classes.paper,
      }}
      onClose={onClose}
      variant="temporary"
    >
      {cardOpened && (
        <PlayerDetails
          playerSlug={cardOpened.playerSlug}
          cardSlug={cardOpened.cardSlug}
          showCardBonusIndicator={false}
          onClose={onClose}
        />
      )}
    </Drawer>
  );
};
